import classNames from 'classnames';
import { graphql } from 'gatsby';
import { Link, useI18next } from 'gatsby-plugin-react-i18next';
import { find, get } from 'lodash';
import { useCallback, useState } from 'react';

import AlubelLogo from '../../images/alubel-logo-gray.svg';

type HeaderProps = {
  data: Queries.HeaderFragment;
};

export function Header({ data }: HeaderProps) {
  const [open, setOpen] = useState(false);
  const { languages, language } = useI18next();

  const menus = data.menus.nodes;

  const getItemsForMenuType = useCallback(
    (type: string) => {
      return find(menus, { type })?.items || [];
    },
    [menus]
  );

  const contactsPage = get(getItemsForMenuType('primary'), '3');

  return (
    <header className={classNames('header', open && 'menu-opened')}>
      <div className='main-menu'>
        <div className='menu1'>
          {getItemsForMenuType('primary').map((item) => (
            <Link key={item!.id} to={item!.link!}>
              {item!.title}
            </Link>
          ))}
        </div>
        <div className='menu2'>
          {getItemsForMenuType('secondary').map((item) => (
            <Link key={item!.id} to={item!.link!}>
              {item!.title}
            </Link>
          ))}
        </div>
        <div className='menu3'>
          {getItemsForMenuType('tertiary').map((item) => (
            <Link key={item!.id} to={item!.link!}>
              {item!.title}
            </Link>
          ))}
        </div>
      </div>
      <Link to='/'>
        <AlubelLogo className='logo' />
      </Link>
      <nav>
        {contactsPage && (
          <Link to={contactsPage.link!}>{contactsPage.title}</Link>
        )}

        {languages
          .filter((lng) => lng !== language)
          .map((language) => (
            <Link key={language} to={'/'} language={language}>
              {language.toUpperCase()}
            </Link>
          ))}
        <div className='toggle-menu' onClick={() => setOpen(!open)}>
          <div />
          <div />
        </div>
      </nav>
    </header>
  );
}

export const query = graphql`
  fragment Header on Query {
    menus: allStrapiMenu(filter: { locale: { eq: $language } }) {
      nodes {
        id
        type
        items {
          id
          link
          title
        }
      }
    }
  }
`;
